import React, { useMemo } from 'react';
import { Box } from '@mantine/core';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import { getIntakeCoordinatesListQuery } from '../../../slices/intakeCoordinates/thunk';

const IntakeCoordinatesPanel = ({ waterRightData }) => {
	
	const columns = useMemo(
		() => [
			{
				header: 'Nombre de Coordenada',
				dataType: 'string',
				accessorKey: 'name',
			},
			{
				header: 'UTM Norte Captación',
				dataType: 'number',
				accessorKey: 'utm_north_intake',
			},
			{
				header: 'UTM Este Captación',
				dataType: 'number',
				accessorKey: 'utm_east_intake',
			},
			{
				header: 'Huso Captación',
				dataType: 'select',
				accessorKey: 'utm_zone.name',
			},
			{
				header: 'Datum Captación',
				dataType: 'select',
				accessorKey: 'geodetic_datum.name',
			},
			{
				header: 'Latitud Captación',
				dataType: 'number',
				accessorKey: 'latitude_intake',
			},
			{
				header: 'Longitud Captación',
				dataType: 'number',
				accessorKey: 'longitude_intake',
			},
		],
		[]
	);

	return (
		<Box
			className='p-2'
			sx={{
				display: 'Grid',
				margin: 'auto',
				width: '100%',
			}}
		>
			<ODataGrid
				columns={columns}
				getDataFunc={getIntakeCoordinatesListQuery}
				baseFilters={{
					water_right_id: { $eq: waterRightData._id },
					disable: { $eq: false },
				}}
				queryPopulate={['utm_zone', 'geodetic_datum']}
				remoteOperations={{
					pagination: true,
					sorting: true,
					filtering: true,
				}}
				nameFile='coordenadas_captacion'
				getRowIdTable={(row) => row._id}
			/>
		</Box>
	);
};

export default IntakeCoordinatesPanel;
